const Dashboard = () => import(/* webpackChunkName: "dashboard" */ './Dashboard.vue')

const route = {
  path: 'dashboard',
  name: 'Dashboard',
  component: Dashboard,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  route
}
